'use es6';

export default (({
  viewFilters
}) => {
  return (state = viewFilters) => {
    return state;
  };
});